import React from "react";
import {
    FaCheckCircle,
    FaTimesCircle,
    FaClock,
    FaFutbol,
} from "react-icons/fa";
import { Carousel } from "@mantine/carousel";
import { Link } from "react-router-dom";

export const predictionData = [
    { id: 1, homeTeam: "Manchester City", awayTeam: "Arsenal", league: "Premier League", date: "2025-01-15", predicted: "Home Win (67%)", actual: "Home Win 2–1", status: "CORRECT", probability: "67%", emblemHome: "/logos/mci.png", emblemAway: "/logos/ars.png", }, { id: 2, homeTeam: "Liverpool", awayTeam: "Chelsea", league: "Premier League", date: "2025-01-14", predicted: "Away Win (52%)", actual: "Draw 1–1", status: "INCORRECT", probability: "52%", emblemHome: "/logos/liv.png", emblemAway: "/logos/che.png", }, { id: 3, homeTeam: "Barcelona", awayTeam: "Real Madrid", league: "La Liga", date: "2025-01-13", predicted: "Draw (42%)", actual: "Draw 2–2", status: "CORRECT", probability: "42%", emblemHome: "/logos/bar.png", emblemAway: "/logos/rma.png", }, { id: 4, homeTeam: "Bayern Munich", awayTeam: "Dortmund", league: "Bundesliga", date: "2025-01-16", predicted: "Home Win (71%)", actual: "Pending", status: "PENDING", probability: "71%", emblemHome: "/logos/fcb.png", emblemAway: "/logos/bvb.png", }, { id: 5, homeTeam: "Inter", awayTeam: "Juventus", league: "Serie A", date: "2025-01-17", predicted: "Under 2.5 (58%)", actual: "Under (1–0)", status: "CORRECT", probability: "58%", emblemHome: "/logos/int.png", emblemAway: "/logos/juv.png", }, { id: 6, homeTeam: "PSG", awayTeam: "Lyon", league: "Ligue 1", date: "2025-01-18", predicted: "Home Win (65%)", actual: "Away Win 1–2", status: "INCORRECT", probability: "65%", emblemHome: "/logos/psg.png", emblemAway: "/logos/lyo.png", }, { id: 7, homeTeam: "Ajax", awayTeam: "PSV", league: "Eredivisie", date: "2025-01-19", predicted: "BTTS Yes (59%)", actual: "BTTS (2–1)", status: "CORRECT", probability: "59%", emblemHome: "/logos/ajax.png", emblemAway: "/logos/psv.png", }, { id: 8, homeTeam: "Porto", awayTeam: "Benfica", league: "Primeira Liga", date: "2025-01-20", predicted: "Draw (35%)", actual: "Pending", status: "PENDING", probability: "35%", emblemHome: "/logos/fcp.png", emblemAway: "/logos/slb.png", },
];

const STATUS = {
    CORRECT: { label: "CORRECT", class: "pc-badge pc-badge--ok", Icon: FaCheckCircle },
    INCORRECT: { label: "INCORRECT", class: "pc-badge pc-badge--bad", Icon: FaTimesCircle },
    PENDING: { label: "PENDING", class: "pc-badge pc-badge--pending", Icon: FaClock },
};

export default function RecentPredictions({
    title = "Recent Predictions",
    subtitle = "Track model performance and see how our predictions compared to actual results.",
    items = predictionData,
}) {
    return (
        <section className="pc-section">
            <style>{`
        .pc-section, .pc-container { box-sizing: border-box; max-width: 100%; overflow-x: clip; }
        .pc-container { max-width: 1400px; margin: 0 auto; padding: 16px; }
        .pc-header { margin-bottom: 10px; }
        .pc-title { margin: 0 0 4px; font-size: 24px; font-weight: 900; }
        .pc-subtitle { margin: 0; color: #64748b; }
        @media (max-width: 768px) {
          .pc-title { font-size: 20px; }
          .pc-subtitle { font-size: 13px; }
        }
      `}</style>

            <div className="pc-container">
                <header className="pc-header">
                    <h2 className="pc-title">{title}</h2>
                    <p className="pc-subtitle">{subtitle}</p>
                </header>

                <Carousel
                    slideSize="33.333%"         
                    breakpoints={[
                        { maxWidth: 1200, slideSize: "50%" }, 
                        { maxWidth: 768, slideSize: "100%", slideGap: "sm" }, 
                    ]}
                    slideGap="md"
                    align="start"
                    loop
                    withIndicators
                    height="auto"
                >
                    {items.map((m) => (
                        <Carousel.Slide key={m.id}>
                            <PredictionCard data={m} />
                        </Carousel.Slide>
                    ))}
                </Carousel>
            </div>

            <div className="row">
                <div className="col-12 text-center" style={{ marginTop: 40 }}>
                    <Link to="/predictions" className="view-more wow fadeInUp animated">
                        View all
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_6718_7111)">
                                <path d="M5.25 4.5L12.75 12L5.25 19.5" stroke="#121212" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12.75 4.5L20.25 12L12.75 19.5" stroke="#121212" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                        </svg>
                    </Link>
                </div>
            </div>
        </section>
    );
}

function PredictionCard({ data }) {
    const {
        homeTeam = "Home",
        awayTeam = "Away",
        league = "Competition",
        date = "2025-01-01",
        predicted = "Predicted: —",
        actual = "Actual: —",
        status = "PENDING",
        probability,
    } = data || {};

    const ST = STATUS[status] || STATUS.PENDING;
    const StatusIcon = ST.Icon;

    return (
        <article className="pc-card">
            <div className="pc-card__head">
                <div className="pc-teams">
                    {homeTeam}
                    <span className="pc-vs">vs</span>
                    {awayTeam}
                </div>
            </div>

            <div className="pc-meta">
                <span className="pc-meta__league">{league}</span>
                <span className="pc-dot" />
                <span className="pc-meta__date">{date}</span>
            </div>

            <div className="pc-lines">
                <div className="pc-line">
                    <span className="pc-line__label">Predicted</span>
                    <span className="pc-line__value">{predicted}</span>
                    {probability && <span className="pc-chip">{probability}</span>}
                </div>
                <div className="pc-line">
                    <span className="pc-line__label">Actual</span>
                    <span className="pc-line__value">{actual}</span>
                </div>
            </div>

            <div className="row" style={{ marginTop: 10 }}>
                <div className="col-12 text-left">
                    <span className={ST.class}>
                        <StatusIcon size={12} />
                        {ST.label}
                    </span>
                </div>
            </div>

            <div className="pc-card__footer">
                <span className="pc-footicon"><FaFutbol /></span>
                <span className="pc-footnote">Powered by Predixio models</span>
            </div>
        </article>
    );
}

export function TeamBadge({ name, emblem }) {
    return (
        <span className="pc-team">
            {emblem ? (
                <img src={emblem} alt={name} className="pc-team__logo" />
            ) : (
                <span className="pc-team__logo pc-team__logo--placeholder">
                    {name[0]}
                </span>
            )}
            <span className="pc-team__name">{name}</span>
        </span>
    );
}
